import { Outlet, useNavigate } from "react-router-dom";
import Home from "./home";
import CustomAppBar from "../components/CustomAppBar";
import { Box, CircularProgress, Paper, useTheme } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { authActions } from "../store/reducer/auth-reducer";
import { get, isEmpty } from "lodash";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { AccountBoxOutlined, AssuredWorkloadOutlined, FactCheckOutlined, Favorite, Folder, FoodBank, GamepadOutlined, GavelOutlined, HomeOutlined, ListOutlined, LocationCity, MarkAsUnreadOutlined, Restore, Support, WalletOutlined } from "@mui/icons-material";
import AlertBar from "../components/AlertBar";
import { homePageActions } from "../store/reducer/home";
import AppHome from "./home/appHome";
import SplashScreen from "../components/SplashScreen";


const Layout = ({ walletBalance, userData, isLoginLoading, selectedMenuName ,homePageData}: any) => {
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession)
    const theme = useTheme();
    const [value, setValue] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [layoutEnable, setLayoutEnable] = useState<any>(false);

    useEffect(()=>{
        if(!isEmpty(homePageData)){
         setLayoutEnable(get(homePageData,'global_batting_status','0'))
        }

        console.log('finalData',finalData.user_id)
        if (!isEmpty(finalData)) {
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getUserDataReq(data))
            dispatch(authActions.getWalletBalanceReq(data))
        } 
     },[homePageData])

    // Load user data from localStorage on component mount
    useEffect(() => {
        const userDataFromStorage = localStorage.getItem('userData');
        const isAuthenticatedFromStorage = localStorage.getItem('isAuthenticated');
        
        if (userDataFromStorage && isAuthenticatedFromStorage === 'true') {
            try {
                const parsedUserData = JSON.parse(userDataFromStorage);
                if (parsedUserData && parsedUserData.user_id) {
                    // Dispatch actions to load user data and wallet balance
                    const data = { 
                        "app_key": "@34Y@#8deepmatka", 
                        "user_id": parsedUserData.user_id 
                    };
                    dispatch(authActions.getUserDataReq(data));
                    dispatch(authActions.getWalletBalanceReq(data));
                }
            } catch (error) {
                console.error('Error parsing userData from localStorage:', error);
            }
        }
    }, [dispatch]);

    // Load wallet balance on mount only (removed auto-refresh)
    useEffect(() => {
        const userDataFromStorage = localStorage.getItem('userData');
        const isAuthenticatedFromStorage = localStorage.getItem('isAuthenticated');
        
        if (userDataFromStorage && isAuthenticatedFromStorage === 'true') {
            try {
                const parsedUserData = JSON.parse(userDataFromStorage);
                if (parsedUserData && parsedUserData.user_id) {
                    const data = { 
                        "app_key": "@34Y@#8deepmatka", 
                        "user_id": parsedUserData.user_id 
                    };
                    
                    // Fetch wallet balance once on mount
                    dispatch(authActions.getWalletBalanceReq(data));
                    
                    // Removed setInterval to prevent auto-refresh every 10 seconds
                }
            } catch (error) {
                console.error('Error parsing userData from localStorage:', error);
            }
        }
    }, [dispatch]);
     
    useEffect(() => {
             

        const dataHome: any = {
            app_key: "@34Y@#8deepmatka",
            user_id: 0,
            player_id: 0
        };
        dispatch(homePageActions.dashboardDataRequest(dataHome))
        
    }, [])

    // useEffect(() => {
    //     if (value == '') {
    //         setValue('home');
    //         navigate('/home')
    //     }
    // }, [value])



    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        if (isEmpty(finalData)) {
            if (newValue === 'home') {
                setValue(newValue);

                const pay: any = {
                    menuname: newValue
                }
                dispatch(homePageActions.selectedMenu(pay))
                navigate('/home')
            } else if (newValue === 'contact-us') {
                setValue(newValue);               
                const pay: any = {
                    menuname: newValue
                }
                dispatch(homePageActions.selectedMenu(pay))
                navigate('/contact-us')
            }else {
                setErrorMessage({ status: true, message: "Login to get access.", severity: "warning", inputName: '' })
            }
        } else {
            const pay: any = {
                menuname: newValue
            }
            dispatch(homePageActions.selectedMenu(pay))

            if (newValue === 'home') {
                setValue(newValue);
                navigate('/home')
            } else if (newValue === 'funds') {
                setValue(newValue);
                navigate('/add-point')
            } else if (newValue === 'mybids') {
                setValue(newValue);
                navigate('/bid-history')
            } else if (newValue === 'passbook') {
                setValue(newValue);
                navigate('/wallet-statement')
            } else if (newValue === 'contact-us') {
                setValue(newValue);
                navigate('/contact-us')
            }
        }


    };

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };





    return (
        <div>
            {/* <SplashScreen/> */}
            {
                (layoutEnable=='1') ?  <div style={{ flex: 1, width: '100%', height: '100vh', backgroundColor: theme.palette.background.default }}>
                <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                <CustomAppBar walletBalance={walletBalance} userData={userData} />
                <Box sx={{ 
                    height: 'calc(100vh-100px)', 
                    paddingLeft: '0px', 
                    paddingRight: '0px', 
                    paddingTop: { lg: '120px', md: '120px', sm: '80px', xs: '80px' }, 
                    overflow: 'auto', 
                    backgroundColor: theme.palette.background.default 
                }}>
                    <Outlet context={{ walletBalance: walletBalance, userData: userData }} />
                </Box>
                <Paper sx={{ 
                    position: 'fixed', 
                    bottom: 0, 
                    left: 0, 
                    right: 0, 
                    backgroundColor: theme.palette.background.paper, 
                    display: 'flex', 
                    justifyContent: 'center',
                    borderTop: `2px solid ${theme.palette.divider}`,
                }} elevation={8}>
                    <BottomNavigation sx={{
                        minWidth: 400,
                        '& .Mui-selected': {
                            color: `${theme.palette.primary.contrastText} !important`,
                            borderRadius:'100%',
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                            '.MuiSvgIcon-root': {
                                color: `${theme.palette.primary.contrastText} !important`,
                            },
                            transform: 'scale(1.1)',
                        },
                        '&.MuiBottomNavigation-root': {
                            backgroundColor: theme.palette.background.paper,
                            height: '70px',
                            padding:'10px',
                            minWidth:'50px',
                            gap:'10px',
                            '.MuiBottomNavigationAction-root': {
                                color: theme.palette.text.secondary,
                                minWidth:'70px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                }
                            }
                        }
    
                    }} value={selectedMenuName} onChange={handleChange} showLabels>
                        <BottomNavigationAction
                            label="My Bids"
                            value="mybids"
                            icon={<GavelOutlined />}
                        />
                         <BottomNavigationAction
                            label="Passbook"
                            value="passbook"
                            icon={<FactCheckOutlined />}
                        />
                        <BottomNavigationAction
                            label="Home"
                            value="home"
                            icon={<HomeOutlined />}
                        />
                        <BottomNavigationAction
                            label="Funds"
                            value="funds"
                            icon={<AssuredWorkloadOutlined/> }
                        />                                      
                        <BottomNavigationAction
                            label="Support"
                            value="contact-us"
                            icon={<MarkAsUnreadOutlined />}
                        />
                    </BottomNavigation>
                </Paper>
    
            </div> : <div style={{ flex: 1, width: '100%', height: '100vh', backgroundColor: theme.palette.background.default }}> 
                <CustomAppBar walletBalance={walletBalance} userData={userData} />
                <Box sx={{ 
                    height: 'calc(100vh-100px)', 
                    paddingLeft: '0px', 
                    paddingRight: '0px', 
                    paddingTop: { lg: '120px', md: '120px', sm: '80px', xs: '80px' }, 
                    overflow: 'auto', 
                    backgroundColor: theme.palette.background.default 
                }}>
                    <AppHome walletBalance={walletBalance} userData={userData} /> 
                </Box>
                <Paper sx={{ 
                    position: 'fixed', 
                    bottom: 0, 
                    left: 0, 
                    right: 0, 
                    backgroundColor: theme.palette.background.paper, 
                    display: 'flex', 
                    justifyContent: 'center',
                    borderTop: `2px solid ${theme.palette.divider}`,
                }} elevation={8}>
                    <BottomNavigation sx={{
                        minWidth: 400,
                        '& .Mui-selected': {
                            color: `${theme.palette.primary.contrastText} !important`,
                            borderRadius:'100%',
                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                            '.MuiSvgIcon-root': {
                                color: `${theme.palette.primary.contrastText} !important`,
                            },
                            transform: 'scale(1.1)',
                        },
                        '&.MuiBottomNavigation-root': {
                            backgroundColor: theme.palette.background.paper,
                            height: '70px',
                            padding:'10px',
                            minWidth:'50px',
                            gap:'10px',
                            '.MuiBottomNavigationAction-root': {
                                color: theme.palette.text.secondary,
                                minWidth:'70px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                }
                            }
                        }
    
                    }} value={selectedMenuName} onChange={handleChange} showLabels>
                        <BottomNavigationAction
                            label="My Bids"
                            value="mybids"
                            icon={<GavelOutlined />}
                        />
                         <BottomNavigationAction
                            label="Passbook"
                            value="passbook"
                            icon={<FactCheckOutlined />}
                        />
                        <BottomNavigationAction
                            label="Home"
                            value="home"
                            icon={<HomeOutlined />}
                        />
                        <BottomNavigationAction
                            label="Funds"
                            value="funds"
                            icon={<AssuredWorkloadOutlined/> }
                        />                                      
                        <BottomNavigationAction
                            label="Support"
                            value="contact-us"
                            icon={<MarkAsUnreadOutlined />}
                        />
                    </BottomNavigation>
                </Paper>
            </div>
            }
            
        </div>
    )
}
// isPageLoading

const mapStateToProps = (state: any) => ({
    isLoginLoading: state.authentication.isLoginLoading,
    userData: state.authentication.userData,
    walletBalance: state.authentication.walletBalance,
    selectedMenuName: state.homepage.selectedMenuName,
    homePageData: state.homepage.homePageData,
    isHomeLoading: state.homepage.isHomeLoading,
})


export default connect(mapStateToProps)(Layout);
